"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Styled = __importStar(require("./Chip.styled"));
function Chip(_a) {
    var disabled = _a.disabled, onClick = _a.onClick, onRemove = _a.onRemove, children = _a.children, className = _a.className;
    return (react_1.default.createElement(Styled.ChipWrapper, { className: className, onClick: onClick },
        children,
        !disabled && (react_1.default.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: onRemove },
            react_1.default.createElement("path", { d: "M10.1649 0.252277C10.6068 -0.108119 11.2586 -0.0823762 11.6705 0.329505C12.0824 0.741386 12.1081 1.39318 11.7477 1.83505L11.6705 1.9205L7.59075 6L11.6705 10.0795C12.1098 10.5188 12.1098 11.2312 11.6705 11.6705C11.2586 12.0824 10.6068 12.1081 10.1649 11.7477L10.0795 11.6705L6 7.59075L1.9205 11.6705L1.83505 11.7477C1.39318 12.1081 0.741386 12.0824 0.329505 11.6705C-0.0823762 11.2586 -0.108119 10.6068 0.252277 10.1649L0.329505 10.0795L4.40925 6L0.329505 1.9205C-0.109835 1.48116 -0.109835 0.768845 0.329505 0.329505C0.741386 -0.0823762 1.39318 -0.108119 1.83505 0.252277L1.9205 0.329505L6 4.40925L10.0795 0.329505L10.1649 0.252277Z", fill: "#154B82" })))));
}
exports.default = Chip;
//# sourceMappingURL=Chip.js.map